import React from "react"
import ChooseCareLink from "./ChooseCareLink"
import { CHOOSE_THE_RIGHT_CARE_HOME_URL } from "../../../../../utils/paths"

import {
  careTypeParagraphCopy,
  careTypeTitleCopy,
  positivelyRatedParagraphCopy,
} from "./shared"

const careHomeIntroText = (
  locationName,
  totalCareHomeCount,
  nursingCareHomeCount,
) =>
  totalCareHomeCount === 1
    ? `There is 1 care home in ${locationName} which ${
        nursingCareHomeCount === 1 ? "offers" : "does not offer"
      } nursing care.`
    : `There are ${totalCareHomeCount} care homes in ${locationName}, with ${nursingCareHomeCount} offering nursing care.`

export default ({
  careType,
  locationName,
  totalCareHomeCount,
  nursingCareHomeCount,
  dementiaCareHomeCount,
  regulatoryBody,
  positivelyRatedCount,
}) => [
  {
    question: `How many care homes are there in ${locationName}`,
    answer: (
      <>
        {careHomeIntroText(
          locationName,
          totalCareHomeCount,
          nursingCareHomeCount,
        )}{" "}
        If you&apos;re not sure which type of care home is best for you, you can
        read our guide on <ChooseCareLink />.
      </>
    ),
    structuredDataAnswer: `${careHomeIntroText(
      locationName,
      totalCareHomeCount,
      nursingCareHomeCount,
    )} If you’re not sure which
    type of care home is best for you, you can read our guide on <a href="${CHOOSE_THE_RIGHT_CARE_HOME_URL}">how to choose the right care home</a>.`,
  },
  {
    question: `How many care homes in ${locationName} offer specialised dementia care?`,
    answer:
      {
        // eslint-disable-next-line max-len
        0: `Unfortunately no care homes in ${locationName} offer specialist care designed to meet the challenges faced by people living with dementia. We recommend you widen your search to surrounding areas for this support.`,
        1: `Only 1 care home in ${locationName} offers specialist care designed to meet the challenges faced by people living with dementia.`,
      }[dementiaCareHomeCount] ||
      `${dementiaCareHomeCount} care homes in ${locationName} offer specialist care designed to meet the challenges faced by people living with dementia.`,
  },
  {
    question: careTypeTitleCopy(careType, locationName),
    answer:
      totalCareHomeCount === 1
        ? `${careTypeParagraphCopy(careType, locationName, regulatoryBody)}`
        : `${careTypeParagraphCopy(
            careType,
            locationName,
            regulatoryBody,
          )} ${positivelyRatedParagraphCopy(
            "care homes",
            locationName,
            totalCareHomeCount,
            positivelyRatedCount,
          )}.`,
  },
]
